(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pj-card-secondary-video')) {
    customElements.define('pj-card-secondary-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.card = this.closest('product-card');
        this.inner = this.closest('.card-inner');
        if (!this.video || !this.card || !this.inner) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.touch = matchMedia('(hover: none)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.hovered = false;
        this.update = () => {
          const wanted = !document.hidden && !matchMedia('(max-width: 749px)').matches && !this.reduced.matches &&
            !this.card.classList.contains('has-swatch-active') &&
            (this.touch.matches ? this.visible : this.visible && this.hovered);
          if (!wanted) {
            this.requested = false;
            this.video.pause();
            this.removeAttribute('data-playing');
            return;
          }
          if (this.requested) return;
          this.requested = true;
          const source = this.video.querySelector('source');
          if (!source.getAttribute('src')) {
            if (!source.dataset.src) { this.setAttribute('data-failed', ''); return; }
            source.src = source.dataset.src;
            this.video.load();
          }
          this.video.muted = true;
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => {
            this.requested = false;
            this.removeAttribute('data-playing');
          });
        };
        this.inner.addEventListener('pointerenter', () => { this.hovered = true; this.update(); }, options);
        this.inner.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
        this.card.addEventListener('focusin', () => { this.hovered = true; this.update(); }, options);
        this.card.addEventListener('focusout', event => {
          if (!this.card.contains(event.relatedTarget)) { this.hovered = false; this.update(); }
        }, options);
        this.video.addEventListener('playing', () => {
          if (this.requested) this.setAttribute('data-playing', '');
          else this.video.pause();
        }, options);
        this.video.addEventListener('error', () => {
          this.setAttribute('data-failed', '');
          this.removeAttribute('data-playing');
        }, options);
        document.addEventListener('visibilitychange', this.update, options);
        this.reduced.addEventListener('change', this.update, options);
        this.touch.addEventListener('change', this.update, options);
        this.swatchObserver = new MutationObserver(this.update);
        this.swatchObserver.observe(this.card, { attributes: true, attributeFilter: ['class'] });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].intersectionRatio >= 0.6;
          this.update();
        }, { threshold: [0, 0.6] });
        this.observer.observe(this.inner);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.swatchObserver?.disconnect();
        this.video?.pause();
      }
    });
  }


  if (!customElements.get('pj-card-mobile-gallery')) {
    customElements.define('pj-card-mobile-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pj-card-gallery-track');
        this.slides = Array.from(this.querySelectorAll('.pj-card-gallery-slide'));
        this.count = this.querySelector('.pj-card-gallery-count');
        this.prev = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');
        this.card = this.closest('product-card');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        this.index = 0;
        this.inView = false;
        this.go = index => this.track.scrollTo({ left: Math.max(0, Math.min(index, this.slides.length - 1)) * this.track.clientWidth, behavior: 'auto' });
        this.refresh = () => {
          if (this.track.clientWidth) this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
          this.prev.disabled = this.index === 0;
          this.next.disabled = this.index === this.slides.length - 1;
          this.slides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (!video) return;
            const active = this.mobile.matches && this.inView && !document.hidden && !this.reduced.matches && i === this.index;
            if (!active) { video.pause(); return; }
            const source = video.querySelector('source');
            if (!source.getAttribute('src') && source.dataset.src) {
              source.src = source.dataset.src;
              video.load();
            }
            if (video.paused) { video.muted = true; video.play()?.catch(() => {}); }
          });
        };
        this.track.addEventListener('scroll', this.refresh, { ...opts, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, opts);
        this.prev.addEventListener('click', () => this.go(this.index - 1), opts);
        this.next.addEventListener('click', () => this.go(this.index + 1), opts);
        let startX = 0, startY = 0, dragged = false;
        this.track.addEventListener('touchstart', event => {
          startX = event.touches[0].clientX; startY = event.touches[0].clientY; dragged = false;
        }, { ...opts, passive: true });
        this.track.addEventListener('touchmove', event => {
          if (Math.abs(event.touches[0].clientX - startX) > 8 || Math.abs(event.touches[0].clientY - startY) > 8) dragged = true;
        }, { ...opts, passive: true });
        this.track.addEventListener('click', event => { if (dragged) { event.preventDefault(); dragged = false; } }, opts);
        document.addEventListener('visibilitychange', this.refresh, opts);
        this.mobile.addEventListener('change', this.refresh, opts);
        this.reduced.addEventListener('change', this.refresh, opts);
        this.resize = new ResizeObserver(() => { this.go(this.index); this.refresh(); });
        this.resize.observe(this.track);
        this.visibility = new IntersectionObserver(entries => { this.inView = entries[0].intersectionRatio >= .6; this.refresh(); }, { threshold: [0, .6] });
        this.visibility.observe(this);
        this.swatches = new MutationObserver(() => {
          if (!this.mobile.matches || !this.card.classList.contains('has-swatch-active')) return;
          const image = this.card.querySelector('.product-card-variant-image:not(.hidden)');
          const srcset = image?.getAttribute('srcset') || image?.getAttribute('data-srcset') || '';
          const index = this.slides.findIndex(slide => srcset.includes(slide.dataset.imagePath));
          if (index >= 0 && index !== this.index) this.go(index);
        });
        this.swatches.observe(this.card, { subtree: true, attributes: true, attributeFilter: ['class'] });
        this.refresh();
      }
      disconnectedCallback() {
        this.abort?.abort(); this.resize?.disconnect(); this.visibility?.disconnect(); this.swatches?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
